import './HScrollContainer.css'

const HScrollContainer: React.FC = (props) => {
  return (
    <div className="h-scroll">
      {props.children}
    </div>
  );
};

export default HScrollContainer;
